import { prop } from 'ramda'
import { combineLatestWith, Observable, of, startWith, switchMap, tap } from 'rxjs'
import { catchError, map } from 'rxjs/operators'

import { Component, Input, OnInit } from '@angular/core'
import { ActivatedRoute } from '@angular/router'

import { LocalesEnum, SocialNetworkEnum } from '@app-graphql/schema'
import { PPageState } from '../../../../pages/page/page.component'
import { LocalizationService } from '@app-domains/localization/service/localization.service'
import { Pages, seoDataStaticPages, SeoService } from '@app-services'

@Component({
    selector: 'app-content-blocks',
    templateUrl: './content-blocks.component.html',
    styleUrls: ['./content-blocks.component.scss'],
})
export class ContentBlocksComponent implements OnInit {
    public state$: Observable<PPageState>

    @Input()
    public fetchFunction: (slug: string, locale: LocalesEnum) => Observable<any>

    @Input()
    public staticSlug?: string

    @Input()
    public slugParameterName?: string

    constructor(
        private readonly route: ActivatedRoute,
        private readonly seo: SeoService,
        private localizationService: LocalizationService,
    ) {
    }

    public ngOnInit(): void {
        const slug$ = this.staticSlug ? of(this.staticSlug) : this.route.params.pipe(
            map(prop<string>(this.slugParameterName ?? 'slug')),
        )

        this.state$ = slug$.pipe(
            combineLatestWith(this.localizationService.currentLocale$),
            switchMap(([slug, locale]) => {
                return this.fetchFunction(
                    slug,
                    locale as LocalesEnum,
                ).pipe(
                    tap((result) => {
                        if (! result?.seo) {
                            const defaultSeoContent = seoDataStaticPages.find(
                                (x) => x.id === Pages.AllProducts,
                            )!.data[locale]

                            const title = (result.name && result.name.length)
                                ? result.name
                                : defaultSeoContent.title

                            const description = (result.description && result.description.length)
                                ? result.description
                                : defaultSeoContent.description

                            const socials = [
                                {
                                    socialNetwork: SocialNetworkEnum.Facebook,
                                    title,
                                },
                                {
                                    socialNetwork: SocialNetworkEnum.Twitter,
                                    title,
                                },
                            ]

                            return this.seo.setSeoData({
                                title,
                                description,
                                socials,
                                image: defaultSeoContent.image,
                            })
                        }

                        this.seo.setSeoData(result.seo)
                    }),
                    map((data) => ({
                        status: 'ready',
                        data,
                    } as PPageState)),
                    catchError((err) => {
                        console.error(err)
                        return of({
                            status: 'not-found',
                        } as PPageState)
                    }),
                )
            }),
            startWith({
                status: 'loading',
            } as PPageState),
        )
    }

}
